module.exports = __webpack_public_path__ + "img/9788994142371.fab584c0.jpg";